/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tl_Show_AllInputs */

const en_tl_show_all = /** @type {(inputs: Tl_Show_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show all dated items`)
};

const de_tl_show_all = /** @type {(inputs: Tl_Show_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle mit Termin zeigen`)
};

/**
* | output |
* | --- |
* | "Show all dated items" |
*
* @param {Tl_Show_AllInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_show_all = /** @type {((inputs?: Tl_Show_AllInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_Show_AllInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_show_all(inputs)
	return en_tl_show_all(inputs)
});